import React from "react";
import { rgba } from "polished";
import { Box } from "rebass";
import styled from "styled-components";

const Wrapper = styled(Box)`
  position: relative;
  background-color: ${(props) => props.theme.colors[props.color]};
  overflow: hidden;
`;

const Image = styled(Box)`
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  z-index: 0;
  width: 75%;
  height: 100%;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  filter: grayscale(1);
  user-select: none;

  /* Fallback */
  background-image: ${(props) =>
    "url(" + (props.backgroundImage ? props.backgroundImage[2] : "") + ")"};

  /* Webkit fallback */
  background-image: ${(props) =>
    "-webkit-image-set(url(" +
    (props.backgroundImage ? props.backgroundImage[2] : "") +
    ") 1x, url(" +
    (props.backgroundImage ? props.backgroundImage[1] : "") +
    ") 2x)"};

  /* Regular imageset */
  background-image: ${(props) =>
    "image-set(url(" +
    (props.backgroundImage ? props.backgroundImage[2] : "") +
    ") 1x, url(" +
    (props.backgroundImage ? props.backgroundImage[1] : "") +
    ") 2x)"};

  @media (min-width: 52em) {
    /* Fallback */
    background-image: ${(props) =>
      "url(" + (props.backgroundImage ? props.backgroundImage[1] : "") + ")"};

    /* Webkit fallback */
    background-image: ${(props) =>
      "-webkit-image-set(url(" +
      (props.backgroundImage ? props.backgroundImage[1] : "") +
      ") 1x, url(" +
      (props.backgroundImage ? props.backgroundImage[1] : "") +
      ") 2x, url(" +
      (props.backgroundImage ? props.backgroundImage[0] : "") +
      ") 3x)"};

    /* Regular imageset */
    background-image: ${(props) =>
      "image-set(url(" +
      (props.backgroundImage ? props.backgroundImage[1] : "") +
      ") 1x, url(" +
      (props.backgroundImage ? props.backgroundImage[1] : "") +
      ") 2x, url(" +
      (props.backgroundImage ? props.backgroundImage[0] : "") +
      ") 3x)"};
  }

  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    background-image: ${(props) =>
      props.theme.colors[props.imageColor] &&
      "linear-gradient(to bottom, " +
        (props.imageColor
          ? rgba(props.theme.colors[props.imageColor], 0.66)
          : "") +
        ", " +
        (props.imageColor
          ? rgba(props.theme.colors[props.imageColor], 0.66)
          : "") +
        "), url(" +
        (props.backgroundImage ? props.backgroundImage[2] : "") +
        ")"};
  }
`;

const Overlay = styled(Box)`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  user-select: none;

  &:before {
    content: "";
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    z-index: 0;
    width: 75%;
    height: 100%;
    background: ${(props) =>
      props.theme.colors[props.color] &&
      "linear-gradient(to right, " +
        rgba(props.theme.colors[props.color], 1) +
        ", " +
        rgba(props.theme.colors[props.color], 0.5) +
        ")"};
    user-select: none;
  }

  &:after {
    content: "";
    position: absolute;
    top: 0;
    bottom: 0;
    z-index: 0;
    width: 100%;
    height: 100%;
    background: ${(props) =>
      props.theme.colors[props.color] &&
      "linear-gradient(to bottom, " +
        rgba(props.theme.colors[props.color], 1) +
        ", " +
        rgba(props.theme.colors[props.color], 0.5) +
        ")"};
    user-select: none;
  }
`;

const Container = styled(Box)`
  position: relative;
  z-index: 1;
`;

const GradientHeader = (props) => (
  <Wrapper
    {...props}
    className={props.className}
    style={props.style}
    color={props.color}
    is="header"
    pt={[137, 80]}
  >
    <Image backgroundImage={props.image} />
    <Overlay color={props.color} />
    <Container className="gradient-header__container">
      <Box
        w="100%"
        pt={[5, 7]}
        pb={[5, 7]}
        mx="auto"
        px={[4, 5, 6, 8]}
        style={{ maxWidth: "90em" }}
      >
        {props.children}
      </Box>
    </Container>
  </Wrapper>
);

GradientHeader.defaultProps = {
  image: [],
};

export default GradientHeader;



// WEBPACK FOOTER //
// ./src/components/GradientHeader.js